import { Select } from "antd";
import { useIntl } from "react-intl";
import { useEffectOnce } from "react-use";

import { TimezonePickerFieldProps } from "./types";
import { timezoneOptions } from "./consts";

const TimezonePickerField: React.FC<TimezonePickerFieldProps> = ({
  autodetect,
  ...props
}) => {
  const intl = useIntl();

  useEffectOnce(() => {
    if (!props.value && autodetect) {
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

      props.onChange?.(timeZone, {
        value: timeZone,
        label: timeZone,
      });
    }
  });

  return (
    <Select
      showSearch
      options={timezoneOptions}
      optionFilterProp="label"
      placeholder={intl.formatMessage({ defaultMessage: "Choose Timezone" })}
      {...props}
    />
  );
};

export default TimezonePickerField;
